<div class="wrap">
    <div class="pull-right" [pTooltip]="getLaufmeterInformationTooltip(teilnahme)" tooltipPosition="left">
        {{teilnahme?.laufmeterSum ? teilnahme.laufmeterSum : '0' }}{{maxTiefe > 0 ? "x" + maxTiefe + 'm' : 'm'}}&nbsp;
    </div>
</div>